import { userSelectors } from "@fitness-app/app-store";
import { PermissionKey, TeamMemberRole, UserRole } from "@fitness-app/data-models";
import { type TeamMemberSettings } from "@fitness-app/data-models/entities/TeamMember";

import { usePermission } from "~/hooks/usePermission";
import { useAppSelector } from "~/store/initializeStore";

export const useUserRole = () => {
  const userRole = useAppSelector(userSelectors.getUserRole);
  const { memberRole: claimedMemberRole } = useAppSelector(userSelectors.getUserClaims);
  const user = useAppSelector((state) => state.user.data);
  const profile = useAppSelector((state) => state.user.profile);
  const selectedMember = useAppSelector((state) => state.team.selectedMember);
  const canWriteClients = usePermission(PermissionKey.CLIENTS_WRITE);
  const hasSalesCrmAccess = usePermission(PermissionKey.SALES_READ);
  const memberRole = claimedMemberRole ?? selectedMember?.role ?? null;
  const memberRoleName = memberRole as string | null;
  const settings: TeamMemberSettings = selectedMember?.settings ?? {};

  return {
    userId: user?.id || "",
    role: userRole,
    isTrainer: userRole === UserRole.TRAINER,
    hasAccessToFitnessFeatures: canWriteClients,
    isClient: userRole === UserRole.CLIENT,
    isTeamMember: userRole === UserRole.TEAM_MEMBER,
    isRegularCoach: memberRoleName === TeamMemberRole.REGULAR_TRAINER || memberRoleName === "TRAINER",
    isHeadCoach: memberRoleName === TeamMemberRole.SHARED_TRAINER || memberRoleName === "HEAD_COACH",
    isSalesRep: memberRoleName === TeamMemberRole.SALES_REP,
    userName: profile ? `${profile.firstName} ${profile.lastName}` : "",
    userAvatar: profile?.avatarUrl || null,
    settings,
    trainerRole: memberRole ?? (userRole === UserRole.TRAINER ? TeamMemberRole.ACCOUNT_OWNER : null),
    isAdministration: memberRoleName === TeamMemberRole.ADMINISTRATION,
    hasSalesCrmAccess,
  };
};
